<script setup>
import HeaderNav from "@/components/headerNav.vue";
import FootNav from "@/components/footNav.vue";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
import {getBannerApi, getNewsArticleQueryApi,} from '@/api/index'
import { ref } from 'vue'
const bannerList = ref([])
const info = ref({})
function getNewsArticleQuery (){
  getNewsArticleQueryApi({type:3}).then(res =>{
    info.value = res.data
  })
}
function  getBanner (){
  getBannerApi({type:3}).then(res => {
    bannerList.value = res.data
  })
}
getBanner()
getNewsArticleQuery()
</script>
<template>
  <div class="box">
    <HeaderNav :isCurrent="2" />
    <div>
      <!-- 轮播图 -->
      <el-carousel height="600px" autoplay>
        <el-carousel-item style="height: auto ;min-height: 600px" v-for="(item ,index) in bannerList" :key="index">
          <img :src="item.picUrl" :alt="item.title">
        </el-carousel-item>
      </el-carousel>
    </div>

    <!--主体内容 开始-->
    <div class="single">
      <!--右侧区域 开始-->
      <div id="right">
        <div class="right_title">
          <!--当前位置 开始-->
          <div id="location">
            <a href="/" target="_self">{{t('首页')}}</a> &nbsp;&gt;&gt;&nbsp;
            <a href="javascript:;">{{t('资质荣誉')}}</a>
          </div>
        </div>
        <div id="subchannel_main">
          <div id="subchannel">
            <ul class="subchannellist">
              <li class="depth1" id="current">
                <a href="javascript:;">{{t('资质荣誉')}}</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="right_body minwidth">
          <div class="ChannelContent">
            <div v-html="info.content"></div>
            <!-- <img src="@/assets/temporary/ryzz.png" style="width: 100%;height: auto" alt=""> -->
          </div>
        </div>
        <div class="right_bottom"></div>
      </div>
      <!--右侧区域 结束-->
      <div class="clear"></div>
    </div>
    <!--主体内容 结束-->
    <div>
      <FootNav />
    </div>
  </div>
</template>
